import type { Locale } from '../i18n.ts'

const STORAGE_KEY = 'taler.locale'

/** Both locales are always on the wire; this is only which one this browser renders. */
export function readStoredLocale(storage: Storage = window.localStorage): Locale | undefined {
  const value = storage.getItem(STORAGE_KEY)
  return value === 'en' || value === 'hu' ? value : undefined
}

export function storeLocale(locale: Locale, storage: Storage = window.localStorage): void {
  storage.setItem(STORAGE_KEY, locale)
}
